import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Form actions is a simple container for actions associated with a form. The component itself does
 * nothing other than provide layout when nested in a
 * `Form` component.
 *
 * @related [`Form`]
 * @since 8.0.0
 */
var FormActions = /*#__PURE__*/styled.div.withConfig({
  displayName: "FormActions",
  componentId: "c11n-8-111-1__sc-1h72c0a-0"
})([""]);
FormActions.displayName = 'FormActions';
FormActions.propTypes = {
  /**
   * Specify the type of the container using the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop).
   *
   * By default, this is a `"div"`, but `ButtonGroup`
   * would be appropriate when there are multiple action buttons.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
};
FormActions.defaultProps = {
  as: 'div'
};

/** @component */
export { FormActions };